<div class="wrapper">
  <div class="header">
    <app-page-info
      [resourceName]="`Паспорт продукта №${productCardId}`"
      [loginAndRoles]="loginAndRoles"
    />
    <button
      mat-button
      color="primary"
      class="header-btn-desc"
      (click)="toggleDesc()"
    >
      <mat-icon>{{ iconDesc() }}</mat-icon>
      {{ tooltipBtnDesc() }}
    </button>
  </div>
  <div class="content">
    <div class="content-header">
      <app-pc-header
        [productCardId]="productCardId"
        [productCardData]="productCardData"
        [isVisibleDesc]="isVisibleDesc()"
      />
      <app-pc-images
        class="content-header-image"
        [class.content-header-image-hidden]="!isVisibleDesc()"
        [productCardId]="productCardId"
        [productCardAvatar]="productCardData.photo || ''"
      />
    </div>
    @if (isProductCardDataLoaded) {
      <app-pc-tables
        class="app-pc-tables"
        [productCardId]="productCardId"
        [productCardData]="productCardData"
        [isVisibleDesc]="isVisibleDesc()"
      />
    }
  </div>
</div>
